import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DataProviderService {
    constructor() {
    }

    description: any;
    productGroupId: any;
    taxName: any;
    taxValue: any;
    groupName: any;
    productGroupCategory: any;

    setDataForAddOrder(desc: any, prodId: any, tN: any, tV: any, gn: any, gc: any) {
        this.description = desc;
        this.productGroupId = prodId;
        this.taxName = tN;
        this.taxValue = tV;
        this.groupName = gn;
        this.productGroupCategory = gc;
    }

    getDataForAddOrder() {
        return {
            description: this.description,
            productGroupId: this.productGroupId,
            taxName: this.taxName,
            taxValue: this.taxValue,
            groupName: this.groupName,
            productGroupCategory: this.productGroupCategory
        };
    }
}
